"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationTab = exports.InstallationTab = void 0;

var _preact = require("preact");

var _PanelItems = require("../PanelItems");

var _AccordionPanel = _interopRequireDefault(require("../../../panel/AccordionPanel"));

var _ExternalLink = require("../../../ui-components/ExternalLink");

var _InstallationPanel = require("./InstallationPanel");

var _Message = require("../../../ui-components/Message");

var _IntegrationPanel = _interopRequireDefault(require("./IntegrationPanel"));

var _constants = require("@insided/shared/constants");

var IntegrationTab = function IntegrationTab(_ref) {
  var isInstalled = _ref.isInstalled,
      isExportEnabled = _ref.isExportEnabled;
  var ExportIntegrationPanel = (0, _IntegrationPanel.default)({
    title: 'Export community member & activity data to Gainsight',
    isInstalled: isInstalled,
    imageFromName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
    imageToName: 'gainsight-s',
    isSettingEnabled: isExportEnabled,
    toggleLabel: 'Automatically export community data to Gainsight',
    communityArticleLink: 'https://community.insided.com/integrations-124/how-to-set-up-the-insided-x-gainsight-integration-1979',
    description: "Get a 360 view of your customers and use community involvement as a top-level contributor for customer health scoring, by exporting ".concat(_constants.PLATFORM_BRAND_NAME, " community member and activity data to Gainsight."),
    additionalHelpText: (0, _preact.h)("span", null, "Follow ", (0, _preact.h)("a", {
      className: "overview-page-link",
      target: "_blank",
      rel: "noreferrer",
      href: "https://essentialsui.gainsightapp.net/solutionapps/Community/inSided/S3/inSided_S3_DeploymentInstructions.pdf"
    }, "the post-deployment instructions"), " for our app in the Gainsight Sightline Vault."),
    integrationStatus: (0, _preact.h)(_Message.Message, {
      variant: "success",
      text: "Community data is exported automatically every 10 minutes."
    }),
    customClass: 'qa-export'
  });
  return (0, _preact.h)("div", {
    className: "integration__tab"
  }, !isInstalled && (0, _preact.h)(_Message.Message, {
    text: "Please install the app first to configure the integrations.",
    fullWidth: true
  }), (0, _preact.h)(_AccordionPanel.default, {
    panels: [ExportIntegrationPanel]
  }));
};

exports.IntegrationTab = IntegrationTab;

var InstallationTab = function InstallationTab(_ref2) {
  var isInstalled = _ref2.isInstalled,
      bucketPath = _ref2.bucketPath,
      accessKey = _ref2.accessKey,
      securityToken = _ref2.securityToken,
      onSave = _ref2.onSave,
      onCancel = _ref2.onCancel,
      onClickManage = _ref2.onClickManage,
      onClickUninstall = _ref2.onClickUninstall,
      hasUnsavedChanges = _ref2.hasUnsavedChanges,
      onChangeBucketAccessPathCallback = _ref2.onChangeBucketAccessPathCallback,
      onClickBucketAccessPathCallback = _ref2.onClickBucketAccessPathCallback,
      onChangeAccessKeyCallback = _ref2.onChangeAccessKeyCallback,
      onClickAccessKeyCallback = _ref2.onClickAccessKeyCallback,
      onChangeSecurityTokenCallback = _ref2.onChangeSecurityTokenCallback,
      onClickSecurityTokenCallback = _ref2.onClickSecurityTokenCallback,
      isSavingCredentials = _ref2.isSavingCredentials,
      errorFields = _ref2.errorFields,
      displayUnsavedChangedModal = _ref2.displayUnsavedChangedModal,
      showUnsavedChangesModal = _ref2.showUnsavedChangesModal,
      _closeModal = _ref2.closeModal,
      _resetChanges = _ref2.resetChanges;
  var InstallationPanel = (0, _InstallationPanel.getInstallationPanel)({
    isInstalled: isInstalled,
    bucketPath: bucketPath,
    accessKey: accessKey,
    securityToken: securityToken,
    onSave: onSave,
    onCancel: onCancel,
    onClickManage: onClickManage,
    onClickUninstall: onClickUninstall,
    hasUnsavedChanges: hasUnsavedChanges,
    onChangeBucketAccessPathCallback: onChangeBucketAccessPathCallback,
    onClickBucketAccessPathCallback: onClickBucketAccessPathCallback,
    onChangeAccessKeyCallback: onChangeAccessKeyCallback,
    onClickAccessKeyCallback: onClickAccessKeyCallback,
    onChangeSecurityTokenCallback: onChangeSecurityTokenCallback,
    onClickSecurityTokenCallback: onClickSecurityTokenCallback,
    errorFields: errorFields,
    isSavingCredentials: isSavingCredentials
  });
  return (0, _preact.h)("div", {
    className: "installation__tab__wrapper"
  }, (0, _preact.h)("div", {
    className: "installation__tab"
  }, (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: 0,
    panels: [InstallationPanel],
    renderUnsavedChangesModal: function renderUnsavedChangesModal() {
      return displayUnsavedChangedModal();
    }
  })), (0, _preact.h)(_PanelItems.UnsavedChangesModal, {
    showUnsavedChangesModal: showUnsavedChangesModal,
    closeModal: function closeModal() {
      return _closeModal();
    },
    resetChanges: function resetChanges() {
      return _resetChanges();
    }
  }), (0, _preact.h)(_ExternalLink.ExternalLink, {
    label: "How to install the Gainsight integration step by step",
    url: "https://community.insided.com/integrations-124/how-to-set-up-the-insided-x-gainsight-integration-1979",
    isExternalLinkForToggle: false
  }));
};

exports.InstallationTab = InstallationTab;